<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import config from "../../../config/config";
import { debounce } from "../../../state/helpers";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 1,
      search: "",
      moment,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedVehicleMake: [],
      },
      chargerList: [],
      modelData: {
        id: "",
        name: "",
      },
      searchData: debounce(() => {
        this.getVehicleModels();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "vehicle_make_name",
          sortable: true,
          label: "Make Name",
        },
        {
          key: "name",
          sortable: true,
          label: "Model Name",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  components: { Multiselect },
  validations: {
    modelData: {
      name: { required },
    },
    typeform: {
      selectedVehicleMake: { required },
    },
  },
  computed: {
    ...mapGetters("vehicle", [
      "getAllVehicleModel",
      "loading",
      "vehicleModelCount",
      "pagination",
      "getShowVehicleModel",
      "getUpdateStatus",
      "getAllMake",
    ]),
  },
  mounted() {
    this.getVehicleModels();
    this.getChargers();
  },
  methods: {
    ...mapActions("vehicle", [
      "getVehicleModel",
      "showVehicleModel",
      "updateVehicleModel",
      "createVehicleModel",
      "deleteVehicleModel",
      "getMake",
    ]),
    getVehicleModels(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getVehicleModel(filters);
    },
    addVehicleModel() {
      this.typeform.selectedVehicleMake = [];
      this.modelData.name = "";
      this.$bvModal.show("bv-modal-add-vehicle-model");
    },
    editVehicleModel(model_id) {
      this.resetForm();
      var data = {
        id: model_id,
      };
      this.showVehicleModel(data).then(() => {
        this.modelData.id = this.getShowVehicleModel.id;
        this.modelData.name = this.getShowVehicleModel.name;
        this.typeform.selectedVehicleMake = this.getShowVehicleModel.user_vehicle_makes;
        this.$bvModal.show("bv-modal-edit-vehicle-model");
      });
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.modelData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.modelData.id);
        fd.append("name", this.modelData.name);
        fd.append("make_id", this.typeform.selectedVehicleMake.id);
        this.updateVehicleModel(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getVehicleModels();
          }
          this.$bvModal.hide("bv-modal-edit-vehicle-model");
        });
      }
    },
    submitAddForm() {
      this.$v.$touch();
      if (this.$v.modelData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("name", this.modelData.name);
        fd.append("make_id", this.typeform.selectedVehicleMake.id);
        this.createVehicleModel(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getVehicleModels();
          }
          this.$bvModal.hide("bv-modal-add-vehicle-model");
        });
      }
    },
    deleteVehicleModels(model_id) {
      if (confirm("Are You Sure to Delete #" + model_id + " Vehicle Model")) {
        const fd = new FormData();
        fd.append("id", model_id);
        this.deleteVehicleModel(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getVehicleModels();
          }
        });
      }
    },
    async getChargers() {
      await this.getMake();
      this.getAllChargerList();
    },
    getAllChargerList() {
      this.chargerList = this.getAllMake.map((item) => ({
        id: item.id,
        name: item.name,
      }));
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getVehicleModels();
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-2">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Vehicle Model ({{ vehicleModelCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <b-button
                    class="page-title-right btn btn-success btn-rounded mr-2 add-btn"
                    @click="
                      addVehicleModel();
                      $bvModal.show('bv-modal-add-vehicle-model');
                    "
                    ><i class="mdi mdi-plus mr-1"></i>
                    Add Vehicle Model
                  </b-button>
                  <a
                    :href="config.appurl + 'download-vehicle-model-data'"
                    class="btn btn-primary btn-md btn-rounded ml-1"
                  >
                    Download All Data
                  </a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllVehicleModel"
                  :fields="fields"
                  :busy="loading"
                  class="table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(vehicle_make_name)="items">
                    {{ items.item.vehicle_make_name ? items.item.vehicle_make_name : "" }}
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="editVehicleModel(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-edit"></i>
                    </b-button>
                    &nbsp;
                    <b-button
                      @click="deleteVehicleModels(items.item.id)"
                      class="btn btn-danger btn-rounded"
                    >
                      <i class="bx bx-trash"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllVehicleModel.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Vehicle Model Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getVehicleModels"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- Add vehicle make Model start -->
    <b-modal id="bv-modal-add-vehicle-model" hide-footer @hidden="resetForm">
      <template #modal-title>Add Vehicle Model</template>
      <form action="#" @submit.prevent="submitAddForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Vehicle Make</label>
              <multiselect
                v-model="typeform.selectedVehicleMake"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                placeholder="Search Vehicle Make"
                open-direction="bottom"
                :options="chargerList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedVehicleMake.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedVehicleMake.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedVehicleMake.required"
                  >Please select vehicle make</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Model Name</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Model Name"
                v-model="$v.modelData.name.$model"
                :class="{ 'is-invalid': $v.modelData.name.$error }"
                name="name"
              />
              <div v-if="$v.modelData.name.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.name.required">Please enter model name</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-add-vehicle-model');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Add vehicle make Model end -->
    <!-- Edit vehicle make Model start -->
    <b-modal id="bv-modal-edit-vehicle-model" hide-footer @hidden="resetForm">
      <template #modal-title>Edit Vehicle Model</template>
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Vehicle Make</label>
              <multiselect
                v-model="typeform.selectedVehicleMake"
                id="ajax"
                v-bind:disabled="typeform.checkbox"
                label="name"
                track-by="name"
                placeholder="Search Vehicle Make"
                open-direction="bottom"
                :options="chargerList"
                :multiple="false"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="true"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :class="{ 'is-invalid': $v.typeform.selectedVehicleMake.$error }"
              >
              </multiselect>
              <div v-if="$v.typeform.selectedVehicleMake.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.selectedVehicleMake.required"
                  >Please select vehicle make</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Name</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Make Name"
                v-model="$v.modelData.name.$model"
                :class="{ 'is-invalid': $v.modelData.name.$error }"
                name="name"
              />
              <div v-if="$v.modelData.name.$error" class="invalid-feedback">
                <span v-if="!$v.modelData.name.required">Please enter make name</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-edit-vehicle-model');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Edit vehicle make Model end -->
  </div>
</template>
<style>
.multiselect {
  width: 100% !important;
}
</style>
